import { Name } from '@shared/interfaces/name.interface';
import { FullNameWithTitle } from '@wtax/data-angular';

export const mapNamePayload = (name?: Name): FullNameWithTitle => ({
  title: name?.title,
  first_name: name?.firstName,
  last_name: name?.lastName,
});
